<template>
  <div class="home">
    <div class="container">
      <div class="text">
        <h1>
          <span class="hov">H</span>
          <span class="hov">i</span>
          <span class="hov">,</span>
        </h1>
        <h1>
          <span class="hov">I</span>
          <span class="hov">'</span>
          <span class="hov">m</span>
          <span class="space"></span>
          <span class="hov">T</span>
          <span class="hov">h</span>
          <span class="hov">o</span>
          <span class="hov">r</span>
          <span class="hov">i</span>
          <span class="hov">q</span>
          <span class="hov">,</span>
        </h1>

        <h1 class="bottom-text">
          <span class="hov">O</span>
          <span class="hov">r</span>
          <span class="hov">d</span>
          <span class="hov">i</span>
          <span class="hov">n</span>
          <span class="hov">a</span>
          <span class="hov">r</span>
          <span class="hov">y</span>          
          <span class="space"></span>
          <span class="hov">P</span>
          <span class="hov">r</span> 
          <div class="right">
            <div class="pupil">
              <div class="light"></div>
            </div>
          </div>
          <span class="hov">g</span>
          <span class="hov">r</span>
          <span class="hov">a</span>
          <span class="hov">m</span>
          <span class="hov">e</span>
          <span class="hov">r</span>
          <span class="hov">.</span>
        </h1>
        <div class="deks">
          <p>Hobbyist programmer</p>
        </div>
        <div @click="menuBackgroundAnim(1)" ref="btn" class="btn">
          <router-link class="contact-btn" to="/about">
            about me
            <span class="btn-arrow">
              <i class="fas fa-arrow-right"></i>
            </span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TransitionMixin from "../mixins/transition";

export default {
  name: "Home",
  mixins: [TransitionMixin],
  data() {
    return {
      toggle: false,
      counter: 1,
      isBoxSupport: true,
    };
  },

  mounted() {
    this.$store.state.hover.push(this.$refs.btn);

    if (window.getComputedStyle(document.body).transformBox !== undefined) {
      this.isBoxSupport = true;
    } else {
      this.isBoxSupport = false;
    }

    const eyes = document.querySelectorAll(".pupil");
    document.onmousemove = function() {
      var x = (event.clientX * 100) / window.innerWidth + "%";
      var y = (event.clientY * 100) / window.innerHeight + "%";
      eyes.forEach((eye) => {
        eye.style.left = x;
        eye.style.top = y;
        eye.style.transform = "translate(-" + x + ", -" + y + ")";
      });
    };
  },
};
</script>

<style scoped src="../../public/styles/home.css"></style>
